import VcTopbarWidget from './widgets/VcTopbarWidget';
import VcControlsWidget from './widgets/VcControlsWidget';
import VcGrowthChartWidget from './widgets/VcGrowthChartWidget';
import VcComparisonWidget from './widgets/VcComparisonWidget';
import VcCalendarWidget from './widgets/VcCalendarWidget';
import VcMonthlyReturnsWidget from './widgets/VcMonthlyReturnsWidget';
import VcTradesListWidget from './widgets/VcTradesListWidget';
import VcKeyInsightsWidget from './widgets/VcKeyInsightsWidget';
import VcGrowthCalculatorWidget from './widgets/VcGrowthCalculatorWidget';
import VcDisclosuresWidget from './widgets/VcDisclosuresWidget';

export const VC_WIDGET_TYPES = {
  vcTopbar: {
    label: 'Top bar',
    description: 'Brand eyebrow, capital base, and date range label.',
    component: VcTopbarWidget,
    defaultSize: { w: 12, h: 2 },
    minSize: { w: 12, h: 2 },
  },
  vcControls: {
    label: 'Controls',
    description: 'Strategy pills, capital base, date range, and admin settings.',
    component: VcControlsWidget,
    defaultSize: { w: 12, h: 5 },
    minSize: { w: 12, h: 4 },
  },
  vcGrowthChart: {
    label: 'Growth chart',
    description: 'Illustrative growth curve with benchmark pills.',
    component: VcGrowthChartWidget,
    defaultSize: { w: 12, h: 9 },
    minSize: { w: 12, h: 6 },
  },
  vcComparison: {
    label: 'Comparison',
    description: 'Strategy vs benchmark comparison tables (all + benchmark tabs).',
    component: VcComparisonWidget,
    defaultSize: { w: 12, h: 10 },
    minSize: { w: 12, h: 6 },
  },
  vcCalendar: {
    label: 'Calendar',
    description: 'Hypothetical daily P&L calendar for selected strategies.',
    component: VcCalendarWidget,
    defaultSize: { w: 12, h: 8 },
    minSize: { w: 12, h: 5 },
  },
  vcMonthlyReturns: {
    label: 'Monthly returns',
    description: 'Monthly return breakdown vs benchmarks.',
    component: VcMonthlyReturnsWidget,
    defaultSize: { w: 12, h: 6 },
    minSize: { w: 12, h: 4 },
  },
  vcTradesList: {
    label: 'Trades list',
    description: 'Simulated trades from strategy equity curves.',
    component: VcTradesListWidget,
    defaultSize: { w: 12, h: 8 },
    minSize: { w: 12, h: 5 },
  },
  vcKeyInsights: {
    label: 'Key insights',
    description: 'Headline performance insights for selected strategies.',
    component: VcKeyInsightsWidget,
    defaultSize: { w: 12, h: 6 },
    minSize: { w: 12, h: 4 },
  },
  vcGrowthCalculator: {
    label: 'Growth calculator',
    description: 'Interactive compound growth calculator.',
    component: VcGrowthCalculatorWidget,
    defaultSize: { w: 12, h: 6 },
    minSize: { w: 12, h: 4 },
  },
  vcDisclosures: {
    label: 'Disclosures',
    description: 'Important legal and hypothetical performance disclosures.',
    component: VcDisclosuresWidget,
    defaultSize: { w: 12, h: 4 },
    minSize: { w: 12, h: 3 },
  },
};

export function getVcWidgetMeta(type) {
  return VC_WIDGET_TYPES[type] || null;
}

export function listVcWidgetTypes() {
  return Object.entries(VC_WIDGET_TYPES).map(([type, meta]) => ({ type, ...meta }));
}
